<template>
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.91699 6.99999H11.0837M11.0837 6.99999L7.00033 2.91666M11.0837 6.99999L7.00033 11.0833" stroke="#504B3F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>